export default function Excel_Ranges() {
  return <div>Excel_Ranges</div>;
}
